import { useAuthStore } from "@/store/auth";
import { useClientStore } from "@/store/client";

export const pageCreationCompteProps = () => ({
  fromPath: {
    type: String,
    required: false,
    default: null
  }
})

export const usePageCreationCompte = (props) => {
  const authStore = useAuthStore();
  const clientStore = useClientStore();
  const router = useRouter();
  const { status: authStatus } = storeToRefs(authStore);
  const { isPorteurCarteCora, isPorteurCarteMalin } = storeToRefs(clientStore);

  const accountCreated = (data) => {
    if (props.fromPath && props.fromPath.includes('activation-carte')) {
      navigateToInternal("/infos-et-services/aide/contactez-nous/formulaire-activation-carte-malin")
    } else {
      router.replace(`/confirmation-creation-compte?${data && data.creationCarteError ? 'erreur=1' : ''}${data && data.creationCarteDejaExistante ? '&carteExistante=1' : ''}`);
    }
  }

  return {
    authStatus,
    isPorteurCarteCora,
    isPorteurCarteMalin,
    accountCreated
  }
}
